const VIEWS_NUMBER = new Intl.NumberFormat('ru-RU');

/** Thousands separated by a space (ru-RU): 12480 -> «12 480». */
export const formatViews = (n: number): string => VIEWS_NUMBER.format(n);
